export default function Brand({ compact = false }) {
  return (
    <div className="brand" aria-label="MakerMargin">
      <div className="brand__mark" aria-hidden="true">
        <span>M</span>
      </div>
      {!compact && (
        <div className="brand__wordmark">
          <span>Maker</span><strong>Margin</strong>
        </div>
      )}
    </div>
  );
}
